<script>
import {api} from "@/modules/api";
import FavoriteList from "@/components/favorites/FavoriteList.vue";

export default {
  name: 'ViewFavorite',
  components: {FavoriteList},
  data () {
    return {
      favorites: {},
      viewModal: false,
      filters: {},
      search: ''
    }
  },
  async mounted () {
    await this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  methods: {
    async loadData() {
      this.favorites = await api.profil.getFavorites()
    }
  }
}
</script>

<template>
  <div>
    <favorite-list :favorites="favorites" />
  </div>
</template>
